<template>
  <div class="gd-pagination">
    <div class="gd-pagination__icon-container"
      @click="goFirst()"
      :class="{ 'disabled' : actualCurrent === 1 }">
      <IconDoubleChevronLeft class="gd-pagination__icon"></IconDoubleChevronLeft>
    </div>
    <div class="gd-pagination__icon-container"
      @click="goPrevious()"
      :class="{ 'disabled' : actualCurrent === 1 }">
      <IconChevronLeft class="gd-pagination__icon"></IconChevronLeft>
    </div>
    {{ actualCurrent }} de {{ Math.ceil(total / limit)}}
    <div class="gd-pagination__icon-container"
      @click="goNext()"
      :class="{ 'disabled' : actualCurrent ===  Math.ceil(total / limit) }">
      <IconChevronRight class="gd-pagination__icon"></IconChevronRight>
    </div>
    <div class="gd-pagination__icon-container"
      @click="goLast()"
      :class="{ 'disabled' : actualCurrent ===  Math.ceil(total / limit) }">
      <IconDoubleChevronRight
        class="gd-pagination__icon">
      </IconDoubleChevronRight>
    </div>
  </div>
</template>

<script>
import IconChevronLeft from '@/assets/svg/icon-chevron-left.svg';
import IconChevronRight from '@/assets/svg/icon-chevron-right.svg';
import IconDoubleChevronLeft from '@/assets/svg/icon-double-chevron-left.svg';
import IconDoubleChevronRight from '@/assets/svg/icon-double-chevron-right.svg';

export default {
  name: 'pagination',

  components: {
    IconChevronLeft,
    IconChevronRight,
    IconDoubleChevronLeft,
    IconDoubleChevronRight,
  },

  data() {
    return {
      actualCurrent: this.current,
    };
  },

  props: {
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
  },

  methods: {
    goFirst() {
      if (this.actualCurrent >= 1) {
        this.actualCurrent = 1;
        this.$emit('pageChange', 0);
      }
    },

    goPrevious() {
      if ((this.actualCurrent * this.limit) - this.limit >= 1) {
        this.actualCurrent -= 1;
        this.$emit('pageChange', (this.actualCurrent * this.limit) - this.limit);
      }
    },

    goNext() {
      if ((this.actualCurrent + 1) <= Math.ceil(this.total / this.limit)) {
        this.$emit('pageChange', (this.actualCurrent * this.limit));
        this.actualCurrent += 1;
      }
    },

    goLast() {
      if (this.actualCurrent <= Math.ceil(this.total / this.limit)) {
        this.actualCurrent = Math.ceil(this.total / this.limit);
        this.$emit('pageChange', (Math.ceil(this.total / this.limit) * this.limit) - this.limit);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pagination.vue